import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";

const Ariskmanagement = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
    </div>
  );
};

export default Ariskmanagement;
